import React, { FC } from "react"
import styled from "@emotion/styled"
import { useTranslation } from "react-i18next"
import Section from "@/components/Section"
import { SectionTitle } from "@/components/Content"
import { mobileFirstDevice } from "@/utils/media-queries"

const Title = styled(SectionTitle)`
  text-align: left;
  padding: 170px 0 70px 0;
  color: ${({ theme }) => theme.colors.black};

  @media ${mobileFirstDevice.tablet} {
    font-size: 34px;
    padding: 90px 0 20px 0;
  }

  @media ${mobileFirstDevice.laptop} {
    padding: 180px 0 20px 0;
    font-size: 64px;
  }
`

const Content = styled.div`
  white-space: pre-wrap;
  text-align: left;
  font-weight: 600;
  font-size: 22px;
  line-height: 125%;
  color: #565f76;
  width: 325px;

  > span {
    color: #000000;
  }

  @media ${mobileFirstDevice.laptop} {
    font-size: 32px;
    width: 800px;
  }
`

const VisionSection: FC = () => {
  const { t } = useTranslation("careers")
  return (
    <Section
      light
      TitleComponent={() => (
        <Title
          dangerouslySetInnerHTML={{
            __html: t("vision.title").replace(/\n/g, "<br />"),
          }}
        ></Title>
      )}
    >
      <Content xs={12}>
        <span>{t("vision.subtitle")} </span>
        <span
          dangerouslySetInnerHTML={{
            __html: t("vision.explanation").replace(/\n/g, "<br />"),
          }}
        />
      </Content>
    </Section>
  )
}

export default VisionSection
